import {relatedAssetsRuleDefaults} from './defaults';
import {SavedSearchRule} from './types';

export const createRelatedAssetsRule = (assetId: number): SavedSearchRule => ({
	...relatedAssetsRuleDefaults,
	elementValue1: assetId,
});

export default createRelatedAssetsRule;
